(function () {
  'use strict';

  var scheduled = false;
  var style = document.getElementById('ln-cart-layout-fix');
  var activeRoot = null;
  var scrollToTopScheduled = false;

  if (!style) {
    style = document.createElement('style');
    style.id = 'ln-cart-layout-fix';
    style.textContent =
      '@keyframes lnCartDrawerIn{from{opacity:.98;visibility:visible;transform:translate3d(0,0,0)}to{opacity:1;visibility:visible;transform:translate3d(-100%,0,0)}}' +
      '@keyframes lnCartDrawerOut{from{opacity:1;visibility:visible;transform:translate3d(-100%,0,0)}to{opacity:.98;visibility:hidden;transform:translate3d(0,0,0)}}' +
      '#cart-drawer.drawer--cart .drawer__inner{will-change:transform;backface-visibility:hidden;overflow:hidden!important}' +
      '#cart-drawer.drawer--cart.is-closing .drawer__inner{animation:lnCartDrawerOut 140ms cubic-bezier(.4,0,1,1) forwards!important}' +
      '#cart-drawer.drawer--cart.is-open .drawer__inner{animation:lnCartDrawerIn 180ms cubic-bezier(.22,1,.36,1) forwards!important}' +
      '#cart-drawer [data-animation]{animation-duration:140ms!important;animation-delay:0ms!important;transition-duration:140ms!important}' +
      '#cart-drawer .cart__item{display:grid!important;grid-template-columns:88px minmax(0,1fr)!important;column-gap:12px!important;align-items:start!important;padding-bottom:12px!important}' +
      '#cart-drawer .cart-block--items,#cart-drawer .cart__item{opacity:1!important;visibility:visible!important}' +
      '#cart-drawer .cart__item{transform:none!important}' +
      '#cart-drawer .cart__item+.cart__item{padding-top:14px!important}' +
      '#cart-drawer .cart__item__image,#cart-drawer .cart__item__image a,#cart-drawer .cart__item__image img{width:88px!important;height:88px!important}' +
      '#cart-drawer .cart__item__image .lazy-image,#cart-drawer .cart__item__image img{opacity:1!important;visibility:visible!important}' +
      '#cart-drawer .cart__item__image{grid-column:1!important;grid-row:1!important}' +
      '#cart-drawer .cart__item__content{grid-column:2!important;grid-row:1!important;align-self:start!important;width:100%!important;max-width:none!important;min-width:0!important;padding:0!important;position:relative!important}' +
      '#cart-drawer .cart__item__content-inner{width:100%!important;padding-right:22px!important}' +
      '#cart-drawer .cart__item__content-inner h4{margin:0 0 3px!important;display:-webkit-box!important;overflow:hidden!important;font-size:14px!important;line-height:1.2!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:2!important}' +
      '#cart-drawer .cart__item__meta{margin:0!important;color:#888!important;font-size:12px!important;line-height:1.2!important}' +
      '#cart-drawer .cart__item__meta strong{font-weight:400!important}' +
      '#cart-drawer .drawer__head{z-index:30!important}' +
      '#cart-drawer .drawer__foot{position:relative!important;inset:auto!important;z-index:31!important;flex:0 0 auto!important;margin-top:0!important;overflow:visible!important;transform:none!important}' +
      '#cart-drawer #ln-related,#cart-drawer .cart__foot__inner{flex:0 0 auto!important}' +
      '#cart-drawer .drawer__body{position:relative!important;inset:auto!important;flex:1 1 0%!important;min-height:0!important;height:auto!important;display:flex!important;flex-direction:column!important;overflow-y:auto!important;overscroll-behavior:contain!important;scroll-padding-top:124px!important;scrollbar-gutter:stable;contain:layout paint}' +
      '#cart-drawer .cart-block:has(.cart-countdown){position:sticky!important;top:54px!important;z-index:29!important;margin:0 0 12px!important;background:#e5f8df!important;box-shadow:0 1px 0 #d7e5d3!important;isolation:isolate!important}' +
      '#cart-drawer .cart-countdown{padding:14px 24px 15px!important}' +
      '#cart-drawer .cart__quantity-price-row{width:100%!important;margin-top:8px!important;display:grid!important;grid-template-columns:88px minmax(0,1fr)!important;gap:10px!important;align-items:center!important}' +
      '#cart-drawer .cart__quantity{width:88px!important;min-height:30px!important;height:30px!important}' +
      '#cart-drawer .cart__price{margin:0!important;display:grid!important;grid-template-columns:auto auto!important;justify-content:end!important;align-items:baseline!important;gap:2px 6px!important;font-size:13px!important;line-height:1.15!important;text-align:right!important}' +
      '#cart-drawer .cart__price del{grid-column:1!important;grid-row:1!important;margin:0!important;color:#8d8d8d!important}' +
      '#cart-drawer .cart__price ins{grid-column:2!important;grid-row:1!important;margin:0!important;color:#d65a5a!important;text-decoration:none!important}' +
      '#cart-drawer .cart__savings{grid-column:1/3!important;grid-row:2!important;justify-self:end!important;color:#149400!important;font-weight:700!important;text-align:right!important}' +
      '#cart-drawer .cart__item__remove{width:18px!important;height:18px!important;position:absolute!important;top:-2px!important;right:0!important;display:grid!important;place-items:center!important;color:#777!important;font-size:0!important;text-decoration:none!important}' +
      '#cart-drawer .cart__item__remove:after{content:"Ã—";font-size:17px!important;font-weight:400!important;line-height:1!important}' +
      '#cart-drawer .cart__checkout,#cart-drawer .cart__checkout:before,#cart-drawer .cart__checkout:after{color:#fff!important;background:#000!important;border-color:#000!important}' +
      '#cart-drawer .ln-related__add{color:#fff!important;background:#000!important;border-color:#000!important}' +
      '#cart-drawer .ln-related__actions{align-items:stretch!important}' +
      '#cart-drawer .ln-related__select,#cart-drawer .ln-related__add{height:38px!important;box-sizing:border-box!important;margin:0!important}' +
      '#cart-drawer .ln-related__add{display:inline-flex!important;align-items:center!important;justify-content:center!important}' +
      '#cart-drawer .ln-related__card{display:grid!important;grid-template-columns:96px minmax(0,1fr)!important;gap:12px!important;align-items:center!important}' +
      '#cart-drawer .ln-related__image-link{grid-column:1!important;grid-row:1!important}' +
      '#cart-drawer .ln-related__content{grid-column:2!important;grid-row:1!important;min-width:0!important}' +
      '@media(max-width:479px){#cart-drawer .cart__item{grid-template-columns:78px minmax(0,1fr)!important;column-gap:10px!important}#cart-drawer .cart__item__image,#cart-drawer .cart__item__image a,#cart-drawer .cart__item__image img{width:78px!important;height:78px!important}#cart-drawer .ln-related__card{grid-template-columns:82px minmax(0,1fr)!important;gap:10px!important}}' +
      '#cart-drawer .ln-related{grid-template-columns:24px minmax(0,1fr) 24px!important;margin-top:auto!important;padding:12px 4px!important;border-bottom:0!important}#cart-drawer .ln-related__actions{padding-right:6px!important;box-sizing:border-box!important}#cart-drawer .ln-related__viewport{overflow:hidden!important;clip-path:inset(0 2px 0 0)}#cart-drawer .ln-related__title{margin:0 0 7px!important;font-size:14px!important;line-height:1.1!important}#cart-drawer .ln-related__card{grid-template-columns:92px minmax(0,1fr)!important;gap:10px!important}#cart-drawer .ln-related__image-link,#cart-drawer .ln-related__image{width:92px!important;height:92px!important}#cart-drawer .ln-related__product-link{font-size:13px!important;line-height:1.2!important;text-overflow:ellipsis!important;white-space:nowrap!important}#cart-drawer .ln-related__prices{min-height:16px!important;margin-top:2px!important;gap:6px!important;font-size:12px!important;line-height:1.1!important}#cart-drawer .ln-related__actions{margin-top:5px!important;grid-template-columns:minmax(0,1fr) 98px!important;gap:6px!important;align-items:stretch!important}#cart-drawer .ln-related__select,#cart-drawer .ln-related__add{height:34px!important;font-size:12px!important}#cart-drawer .ln-related__select{border-right:0!important}#cart-drawer .ln-related__add{border:0!important;box-shadow:none!important}#cart-drawer .ln-related__add{padding:0 9px!important}#cart-drawer .ln-related__arrow{width:24px!important;height:44px!important;font-size:24px!important}@media(max-width:479px){#cart-drawer .ln-related{grid-template-columns:22px minmax(0,1fr) 22px!important;padding:12px 3px!important}#cart-drawer .ln-related__card{grid-template-columns:86px minmax(0,1fr)!important;gap:9px!important}#cart-drawer .ln-related__image-link,#cart-drawer .ln-related__image{width:86px!important;height:86px!important}#cart-drawer .ln-related__actions{grid-template-columns:minmax(0,1fr) 92px!important;gap:5px!important}#cart-drawer .ln-related__select,#cart-drawer .ln-related__add{height:33px!important;font-size:11.5px!important}}' +
      '@media(prefers-reduced-motion:reduce){#cart-drawer.drawer--cart .drawer__inner{animation-duration:1ms!important}}';
    document.head.appendChild(style);
  }

  var TIMER_KEY = 'ln_cart_countdown_end_v2';
  var TIMER_DURATION = 10 * 60 * 1000;
  var timerScheduled = false;

  function updateTimer() {
    timerScheduled = false;

    var timer = document.getElementById('cart-timer');
    if (!timer) return;

    var endTime = parseInt(localStorage.getItem(TIMER_KEY), 10);

    if (!endTime || endTime <= Date.now()) {
      endTime = Date.now() + TIMER_DURATION;
      localStorage.setItem(TIMER_KEY, String(endTime));
    }

    var remaining = Math.max(0, endTime - Date.now());
    var minutes = Math.floor(remaining / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);
    timer.textContent = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function scheduleTimer() {
    if (timerScheduled) return;
    timerScheduled = true;
    requestAnimationFrame(updateTimer);
  }

  function scheduleCartTop() {
    if (scrollToTopScheduled) return;
    scrollToTopScheduled = true;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToTopScheduled = false;

        var drawer = document.getElementById('cart-drawer');
        var body = drawer && drawer.querySelector('.drawer__body');
        if (drawer && drawer.classList.contains('is-open') && body) {
          body.scrollTop = 0;
        }
      });
    });
  }

  function boot() {
    scheduled = false;

    var root = document.getElementById('ln-related');
    if (!root) return;

    if (window.LNRelatedCart && typeof window.LNRelatedCart.init === 'function') {
      var body = document.querySelector('#cart-drawer .drawer__body');
      var items = body && body.querySelector('.cart-block--items');
      var mounted = body && root.parentElement === body && (!items || root.previousElementSibling === items);

      if (root !== activeRoot || !mounted) {
        var rootChanged = root !== activeRoot;
        activeRoot = root;
        root.dataset.lnLoaderReady = 'true';
        window.LNRelatedCart.init();
        if (rootChanged) scheduleCartTop();
      }

      return;
    }

    if (root.dataset.lnBooting === 'true') return;

    var holder = root.closest('.cart__custom-code') || root.parentElement;
    var source = holder && Array.prototype.find.call(holder.querySelectorAll('script'), function (script) {
      return script.textContent.indexOf('LNRelatedCart') !== -1;
    });

    if (!source) {
      root.dataset.lnLoaderReady = '';
      return;
    }

    root.dataset.lnBooting = 'true';
    activeRoot = root;

    var executable = document.createElement('script');
    executable.textContent = source.textContent;
    document.head.appendChild(executable);
    executable.remove();
    scheduleCartTop();
  }

  function scheduleBoot() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot, { once: true });
  } else {
    scheduleBoot();
  }

  new MutationObserver(scheduleBoot).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  new MutationObserver(scheduleTimer).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  scheduleTimer();
  setInterval(updateTimer, 1000);

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.ln-related__arrow');
    if (!arrow) return;

    var root = arrow.closest('#ln-related');
    var track = root && root.querySelector('.ln-related__track');
    var cards = track && track.querySelectorAll('.ln-related__card');
    if (!root || !track || !cards.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var index = Number(root.dataset.lnIndex || 0);
    index += arrow.classList.contains('ln-related__arrow--next') ? 1 : -1;
    index = (index + cards.length) % cards.length;
    root.dataset.lnIndex = String(index);
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
  }, true);

  document.addEventListener('cart:updated', scheduleBoot);
  document.addEventListener('shopify:section:load', scheduleBoot);
})();

